import clsx from "clsx";
import React from "react";

import {
  Modal,
  ModalBody,
  ModalHeader,
  SlashCircleIcon,
} from "@transfr-inc/dashboard-components";
import { formatDateDigits } from "@transfr-inc/dashboard-components/utils";

import "./sync-integration-errors.modal.scss";

export default ({ open, onClose, errors }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      modalClassName={clsx("sync-errors-modal")}
    >
      <ModalHeader
        icon={["fa-regular", "triangle-exclamation"]}
        title="Errors"
        className={clsx("error-icon")}
      />
      <ModalBody>
        {(!errors || errors?.length === 0) && (
          <div className="no-data-message">
            <SlashCircleIcon />
            <span>No errors to display.</span>
          </div>
        )}
        {errors?.length > 0 && (
          <ul className="errors-list">
            {errors?.map((item, index) => (
              <li className="error-item" key={`log.${index}`}>
                <span className="log-date">
                  {formatDateDigits(item.timestamp, true)}
                </span>
                <span className="error-description">
                  {item.message
                    ? item.message.replace(/\\u0027/g, "'")
                    : item["exception_message"]}
                </span>
                <span className="error-payload">{item.payload}</span>
              </li>
            ))}
          </ul>
        )}
      </ModalBody>
    </Modal>
  );
};
